import reports from './ProjectHighlight.module.css'
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from '@ag-grid-community/react';
import "ag-grid-community/styles/ag-theme-quartz.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog } from 'primereact/dialog';
import { useProjHighlight } from '../../../Hooks/Features/ProjectHighlight/useProjHighlight.js';
import { useCommon } from '../../../Hooks/Common/useCommon.js';
import { SkeletonDataTable } from '../../../components/Loader/Loader.jsx';
import AddOrEditProject from '../../../components/ProjectHighLight/AddOrEditProject.jsx';
import DatePicker from 'react-multi-date-picker';
import CommonFilterDropdown from '../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown.jsx';

const ProjectHighlight = () => {

    const { checkPermission } = useCommon();
    const { tagRef, onFilterTextBoxChanged, getProjectHighlights, columnDefs, rowData, loader, onCellClicked, gridRef, pinnedBottomRowData, addProjectPopup, setAddProjectPopup, setSelectProjectId, selectProjectId, filterOpts, filterValues, setFilterValues, hoveredRange, setHoveredRange, isChange, setIsChange, isFilterChange, setIsFilterChange, historyPopup, setHistoryPopup, historyRowData, historyColDef, historyLoader } = useProjHighlight();

    const setFilterValuesFromTemplate = (val, type) => {
        setFilterValues((prev) => ({ ...prev, [type]: val }));
        setIsFilterChange(true);
    }

    const callApi = () => { if (isFilterChange) { getProjectHighlights(); setIsFilterChange(false) } }

    return (
        <div>
            <div className='row mt-2 mx-2'>
                <div className='col-md-2 col-xs-12'>
                    <h5>Project Highlight</h5>
                </div>
                <div className='col-md-8 col-xs-12 '>
                    <div className="row align-items-center g-2">
                        <div className='w25  col-md-3 col-12'>
                            <input placeholder='Search...' type="text"
                                className='input-dd'
                                id="filter-text-box" onInput={onFilterTextBoxChanged} />
                        </div>
                        <div className='col-md-3 col-12 px-1'>
                            <DatePicker value={hoveredRange} onChange={(date) => { setHoveredRange(date); setFilterValues((prev) => ({ ...prev, apiCall: true })) }} range rangeHover placeholder="Select Date" />
                        </div>
                        <div className='col-md-6 col-12'>
                            <CommonFilterDropdown
                                fields={[
                                    { key: "project_category", label: "Client", col: 6, type: "dropdown" },
                                    { key: "project_leads", label: "Project Lead", col: 6 },
                                ]}
                                filterValues={filterValues}
                                setFilterValues={setFilterValues}
                            />
                        </div>
                    </div>
                </div>
                <div className='col-md-2 col-xs-12 text-right' ref={() => checkPermission("project highlight", tagRef)}>
                    <button className='btn btn-default' onClick={() => getProjectHighlights()}><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
                    <button ref={tagRef} className='btn btn-primary' id='{"tabname": "Project Highlight", "data": "project_highlight_add_project_btn"}' onClick={() => setAddProjectPopup(true)}><span className="srkay-add"></span>  Project</button>
                </div>
            </div>
            {loader ? <SkeletonDataTable numSkeletons={20} /> :
                <div ref={() => checkPermission("project highlight", tagRef)}>
                    <div ref={tagRef} id='{"tabname": "Project Highlight", "data": "project_highlight_li"}' className={`ag-theme-alpine ${reports['project-report']}`} >
                        <AgGridReact columnDefs={columnDefs} rowData={rowData}
                            // loading={loader}
                            onCellClicked={onCellClicked}
                            ref={gridRef}
                            rowHeight={24}
                            headerHeight={30}
                            pinnedBottomRowData={pinnedBottomRowData}
                        />
                    </div>
                </div>
            }
            {
                addProjectPopup && <AddOrEditProject addProjectPopup={addProjectPopup} setAddProjectPopup={setAddProjectPopup} selectProjectId={selectProjectId} setSelectProjectId={setSelectProjectId} getProjectHighlights={getProjectHighlights} />
            }

            <Dialog header="Project Allocation History" visible={historyPopup} onHide={() => setHistoryPopup(false)} className='modal-medium' draggable={false}>
                <div style={{ height: '50vh' }} className='ag-theme-alpine'>
                    {historyLoader ? <SkeletonDataTable numSkeletons={12} /> :
                        <AgGridReact rowData={historyRowData} columnDefs={historyColDef} rowHeight={30} headerHeight={30} />
                    }
                </div>
            </Dialog>
        </div>
    );
};

export default ProjectHighlight;



